/**
 * Every condition is optional, but at least one must be set - the backend rejects a rule with none,
 * because such a rule would silently match every treatment.
 */
export interface TreatmentAssignmentRuleSaveModel {
    readonly name: string;
    readonly isActive: boolean;
    readonly treatmentTypeOriginalId?: number | null;
    /** Empty means every sub type of the treatment type, so it never has to be enumerated. */
    readonly treatmentSubTypeOriginalIds: readonly number[];
    readonly organizationId?: string | null;
    readonly officeId?: string | null;
    readonly region?: number | null;
    readonly stripeProductType?: number | null;
    readonly designerUserId?: string | null;
}
